<div class="section-header">
  <div class="title">{{ TemplateNodeTitle || ('audit.node.addArticleElement.articles' | translate) }}</div>
  <itl-button class="button" (click)="autocomplete.openSearchView()">
    <ion-icon class="icon" name="alberta-add"></ion-icon>
    <span class="text">{{ 'audit.node.addArticleElement.add_Article' | translate }}</span>
  </itl-button>
</div>
<!-- We hide the autocomplete input and only open the modal when the user clicks the add article button. -->
<itl-autocomplete
  #autocomplete
  style="display: none"
  [restriction]="restriction"
  [useLogicalAnd]="true"
  [required]="true"
  placeholder="Bitte wählen Sie einen Artikel"
  type="article"
  [showDeleteButton]="false"
  title="Artikel"
  (selectedChange)="articleAdded($event)"
  [fullPageModal]="true"
  [articleFromDocument]="false"
>
</itl-autocomplete>

<div>
  <itl-card-2 *ngFor="let article of articles" class="article-list-item">
    <itl-article-list-item
      [article]="article"
      [labels]="labels"
      [actions]="actions"
      [stars]="stars"
    ></itl-article-list-item>
    <ng-template #actions>
      <itl-icon-button icon="alberta-trash" (click)="handleRemove(article._id)"></itl-icon-button>
      <itl-number-up-down-2 [(value)]="article.quantity" [minValue]="1"></itl-number-up-down-2>
      <itl-article-select-packaging-unit
        [packagingUnits]="article.packagingUnits"
        [(value)]="article.packagingUnit"
      ></itl-article-select-packaging-unit>
    </ng-template>
    <ng-template #labels>
      <itl-label *ngIf="article.pharmacyOnly" [labelStyle]="'infoLabel'" [icon]="'alberta-pharmacy-only'"
        >{{ 'article.details.pharmacyOnly' | translate }}
      </itl-label>
    </ng-template>
    <ng-template #stars>
      <itl-rating-stars [rating]="article.stars" [assortmentType]="article.assortmentType"> </itl-rating-stars>
    </ng-template>
    <div class="annotation-container">
      <itl-card-2>
        <itl-textarea
          [title]="'annotation' | translate"
          (change)="handleAnnotationChange($event.target.value, article._id)"
          icon="alberta-comment"
          [placeholder]="'audit.node.addAnnotation' | translate"
          [(ngModel)]="article.annotation"
        >
        </itl-textarea>
      </itl-card-2>
    </div>
  </itl-card-2>
</div>
